<template>
  <div>
    <div class="w-100 text-right">
      <b-button variant="outline-success" @click="downloadExcel" :disabled="loading.exporting">
        <span v-if="!loading.exporting" class="mb-1"><feather-icon icon="DownloadIcon" /></span>
        <span class="mt-1" v-if="loading.exporting"><b-spinner small  /> </span>
        {{$t('Exportar Tarifa')}}
      </b-button>
    </div>
    <div class="places-history-auditor-connect">
      <form-render
        ref="formTableAuditorConnect"
        :key="keyTableAuditorConnect"
        :fields="fields"
        :form.sync="dataTableAuditorConnect.form"
        :containerButtonsClass="'col-lg-2 col-md-12 col-sm-12 mt-2 mb-2'"
      >
        <template #buttons>
          <div class="d-flex">
            <b-button variant="outline-warning" :disabled="dataTableAuditorConnect.loading.coverages" @click="sendData">
              <b-spinner v-if="dataTableAuditorConnect.loading.coverages" small></b-spinner>
              <feather-icon icon="SearchIcon" v-if="!dataTableAuditorConnect.loading.coverages"/>
            </b-button>
            <b-button variant="outline-light" v-b-tooltip.hover title="Limpiar filtros" class="ml-1 mr-1" @click="clean" :disabled="dataTableAuditorConnect.loading.coverages">
              <feather-icon icon="RefreshCwIcon" />
            </b-button>
          </div>
        </template>
      </form-render>
      <div class="align-content-center text-right">
        <a class="text-primary font-weight-bold align-content-center" @click="openModal('ModalTariffsConnectHistory')">
          <span class="icon-class-tariff"><feather-icon icon="ClockIcon" class="iconClass" size="16" /></span>
          <span>Historial de tarifas</span>
        </a>
      </div>
    </div>
    <modal-tariffs-connect-history :dataHistory="dataHistory" v-if="ModalTariffsConnectHistory" @closeModal="closeModal" @changeRate="changeRateTable"></modal-tariffs-connect-history>
  </div>
</template>

<script>
import ModalTariffsConnectHistory from './ModalTariffsConnectHistory.vue'

export default {
  name: 'AuditorConnectTable',
  components: { ModalTariffsConnectHistory },
  props: {
    changeRate: {
      type: Function,
      default: () => {}
    },
    getCoverages: {
      type: Function,
      default: () => {}
    },
    form: {
      type: Object,
      default: () => {}
    },
    cleanFilter: {
      type: Function,
      default: () => {}
    },
    dataTableAuditorConnect: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      ModalTariffsConnectHistory: false,
      loading: {
        exporting: false
      },
      dataHistory: {},
      arrayCurrentKgs: [],
      keyTableAuditorConnect: 0,
      fields: [
        { fieldType: 'FieldInput', name: 'place_name_from', label: 'Origen', containerClass: 'col-lg-4 col-md-12 col-sm-12' },
        { fieldType: 'FieldInput', name: 'place_name_to', label: 'Destino', containerClass: 'col-lg-4 col-md-12 col-sm-12' }
      ]
    }
  },
  methods: {
    openModal(modal) {
      this[modal] = true
      this.dataHistory = {
        rates: this.dataTableAuditorConnect?.rates || [],
        selectedRate: this.dataTableAuditorConnect?.selectedRate || {}
      }
      this.$nextTick(() => {
        this.$bvModal.show(modal)
      })
    },
    closeModal(modal) {
      this.$bvModal.hide(modal)
      this[modal] = false
    },
    downloadExcel() {
      this.loading.exporting = true
      const params = {
        connect_rate_id: this.dataTableAuditorConnect?.selectedRate?.id
      }
      const queryParams = {
        company_id: this.dataTableAuditorConnect.form?.idSeller?.id
      }
      const props = {
        name: 'postExportFiles',
        params,
        fileName: `Tarifas courier ${this.dataTableAuditorConnect?.form?.carrier?.name} servicio ${this.dataTableAuditorConnect?.form?.service?.name}`,
        showToast:  true,
        queryParams,
        onSuccess: () => this.onLoadedExcel(),
        onError: () => this.onLoadedExcel()
      }
      this.$store.dispatch('fetchServiceGenerateExcel', props)
    },
    onLoadedExcel () {
      this.loading.exporting = false
    },
    changeRateTable(rate) {
      this.$emit('changeRate', rate)
    },
    sendData() {
      this.$emit('getCoverages', this.dataTableAuditorConnect.form)
    },
    clean() {
      this.$emit('cleanFilter', {aditionalFilter: true})
    }
  }
}
</script>
<style lang="scss">
.places-history-auditor-connect {
  display: grid;
  grid-template-columns: 4fr 1fr;
}
</style>